module.exports = __webpack_public_path__ + "media/images/home/intro01-673d168a061f9a209c55eb6a38607cb8.svg";